import Model from '@/models/Model'

export default class PosSale extends Model {
    resource() {
        return 'pos_sale'
    }
}